(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-spec-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-spec-filters')) {
    customElements.define(
      'ss-spec-filters',
      class extends HTMLElement {
        connectedCallback() {
          if (this.isReady) return;
          this.isReady = true;
          this.section = this.closest('.shopify-section');
          this.disclosure = this.querySelector('details');
          this.layoutQuery = window.matchMedia('(min-width: 990px)');
          this.syncDisclosure = ({ matches }) => {
            this.disclosure.open = matches;
          };
          this.syncDisclosure(this.layoutQuery);
          this.layoutQuery.addEventListener('change', this.syncDisclosure);
          this.groups = [...this.querySelectorAll('[data-ss-range-filter]')];
          this.resetButton = this.querySelector('[data-ss-spec-reset]');
          this.stockOnly = this.querySelector('[data-ss-stock-only]');
          this.stockOnly.addEventListener('change', () => this.apply());
          this.count = this.querySelector('[data-ss-spec-count]');
          this.empty = this.querySelector('[data-ss-spec-empty]');
          this.gridContainer = this.section.querySelector('#ProductGridContainer');
          this.numberFormatter = new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
            maximumFractionDigits: 0
          });
          this.handleInput = this.handleInput.bind(this);
          this.queueApply = this.queueApply.bind(this);

          this.refreshItems();
          this.groups.forEach((group) => {
            const inputs = [...group.querySelectorAll('input[type="range"]')];
            inputs.forEach((input) => input.addEventListener('input', this.handleInput));
            this.setBounds(group);
            this.updateGroup(group);
          });

          this.resetButton.addEventListener('click', () => {
            this.stockOnly.checked = false;
            this.groups.forEach((group) => {
              const minInput = group.querySelector('[data-ss-bound="min"]');
              const maxInput = group.querySelector('[data-ss-bound="max"]');
              minInput.value = minInput.min;
              maxInput.value = maxInput.max;
              this.updateGroup(group);
            });
            this.apply();
          });

          this.observer = new MutationObserver(this.queueApply);
          this.observer.observe(this.gridContainer, { childList: true, subtree: true });
          this.apply();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          if (this.layoutQuery && this.syncDisclosure) {
            this.layoutQuery.removeEventListener('change', this.syncDisclosure);
          }
        }

        refreshItems() {
          this.items = [...this.section.querySelectorAll('[data-ss-spec-card]')];
        }

        setBounds(group) {
          const divisor = Number(group.dataset.ssDivisor) || 1;
          const step = Number(group.dataset.ssStep) || 1;
          const values = this.items
            .map((item) => Number(item.dataset[group.dataset.ssDataset]) / divisor)
            .filter((value) => Number.isFinite(value) && value > 0);
          if (!values.length) return;

          const lower = Math.floor(Math.min(...values) / step) * step;
          let upper = Math.ceil(Math.max(...values) / step) * step;
          if (upper <= lower) upper = lower + step;

          const minInput = group.querySelector('[data-ss-bound="min"]');
          const maxInput = group.querySelector('[data-ss-bound="max"]');
          minInput.min = lower;
          minInput.max = upper;
          minInput.step = step;
          minInput.value = lower;
          maxInput.min = lower;
          maxInput.max = upper;
          maxInput.step = step;
          maxInput.value = upper;
        }

        handleInput(event) {
          const group = event.target.closest('[data-ss-range-filter]');
          const minInput = group.querySelector('[data-ss-bound="min"]');
          const maxInput = group.querySelector('[data-ss-bound="max"]');
          if (Number(minInput.value) > Number(maxInput.value)) {
            if (event.target.dataset.ssBound === 'min') {
              maxInput.value = minInput.value;
            } else {
              minInput.value = maxInput.value;
            }
          }
          this.updateGroup(group);
          this.apply();
        }

        updateGroup(group) {
          const minInput = group.querySelector('[data-ss-bound="min"]');
          const maxInput = group.querySelector('[data-ss-bound="max"]');
          const min = Number(minInput.value);
          const max = Number(maxInput.value);
          const lower = Number(minInput.min);
          const upper = Number(maxInput.max);
          const span = upper - lower || 1;
          group.style.setProperty('--ss-range-start', `${((min - lower) / span) * 100}%`);
          group.style.setProperty('--ss-range-end', `${((max - lower) / span) * 100}%`);
          minInput.setAttribute('aria-valuetext', this.formatValue(group, min));
          maxInput.setAttribute('aria-valuetext', this.formatValue(group, max));
          group.querySelector('[data-ss-output="min"]').textContent = this.formatValue(group, min);
          group.querySelector('[data-ss-output="max"]').textContent = this.formatValue(group, max);
        }

        formatValue(group, value) {
          const formatted = this.numberFormatter.format(value);
          if (group.dataset.ssUnit === 'currency') return `CHF ${formatted}`;
          return `${formatted} ${group.dataset.ssUnit}`;
        }

        queueApply() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.apply());
        }

        apply() {
          const previousItems = this.items || [];
          this.refreshItems();
          if (this.items.length !== previousItems.length || this.items.some((item, i) => item !== previousItems[i])) {
            this.groups.forEach(group => { this.setBounds(group); this.updateGroup(group); });
          }
          const selected = Object.fromEntries(
            this.groups.map((group) => {
              const min = Number(group.querySelector('[data-ss-bound="min"]').value);
              const max = Number(group.querySelector('[data-ss-bound="max"]').value);
              const active = min !== Number(group.querySelector('[data-ss-bound="min"]').min) || max !== Number(group.querySelector('[data-ss-bound="max"]').max);
              return [group.dataset.ssRangeFilter, { group, min, max, active }];
            })
          );
          let visible = 0;

          this.items.forEach((item) => {
            const matches = (!this.stockOnly.checked || item.dataset.ssAvailable === 'true') && Object.values(selected).every(({ group, min, max, active }) => {
              if (!active) return true;
              const divisor = Number(group.dataset.ssDivisor) || 1;
              const value = Number(item.dataset[group.dataset.ssDataset]) / divisor;
              return Number.isFinite(value) && value > 0 && value >= min && value <= max;
            });

            item.hidden = !matches;
            item.classList.toggle('hidden', !matches);
            if (matches) {
              item.removeAttribute('aria-hidden');
              visible += 1;
            } else {
              item.setAttribute('aria-hidden', 'true');
            }
          });

          const label = visible === 1 ? this.dataset.resultOne : this.dataset.resultOther;
          this.count.textContent = `${visible} ${label}`;
          this.empty.hidden = visible !== 0;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
